import React from 'react';
import { X, Check } from 'lucide-react';
interface FilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedCategories: string[];
  onCategoryToggle: (category: string) => void;
  onClearAll: () => void;
  onApply: () => void;
  categoryCounts: Record<string, number>;
}
export function FilterModal({
  isOpen,
  onClose,
  selectedCategories,
  onCategoryToggle,
  onClearAll,
  onApply,
  categoryCounts
}: FilterModalProps) {
  if (!isOpen) return null;
  const categories = [{
    id: 'Sportswear',
    label: 'Sportswear',
    count: categoryCounts['Sportswear'] || 0
  }, {
    id: 'Food & Beverage',
    label: 'Food & Beverage',
    count: categoryCounts['Food & Beverage'] || 0
  }, {
    id: 'Technology',
    label: 'Technology',
    count: categoryCounts['Technology'] || 0
  }, {
    id: 'Fashion',
    label: 'Fashion',
    count: categoryCounts['Fashion'] || 0
  }, {
    id: 'Beauty',
    label: 'Beauty',
    count: categoryCounts['Beauty'] || 0
  }];
  const activeFilterCount = selectedCategories.length;
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 z-40 animate-in fade-in duration-200" onClick={onClose} data-id="element-65" />

      {/* Modal Card - Top Middle */}
      <div className="fixed top-[15%] left-1/2 -translate-x-1/2 w-[80%] max-w-sm bg-white rounded-2xl z-50 shadow-2xl animate-in fade-in zoom-in duration-300" data-id="element-66">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200" data-id="element-67">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-68">Filters</h2>
          <button onClick={onClose} className="w-9 h-9 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors active:scale-95" data-id="element-69">
            <X size={18} className="text-gray-600" data-id="element-70" />
          </button>
        </div>

        {/* Content */}
        <div className="px-4 py-3 max-h-[45vh] overflow-y-auto" data-id="element-71">
          <h3 className="font-bold text-gray-900 mb-2 text-sm" data-id="element-72">Category</h3>
          <div className="space-y-1.5" data-id="element-73">
            {categories.map(category => <button key={category.id} onClick={() => onCategoryToggle(category.id)} className="w-full flex items-center justify-between p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors active:scale-[0.98]" data-id="element-74">
                <div className="flex items-center gap-2.5" data-id="element-75">
                  <div className={`w-5 h-5 rounded-lg border-2 flex items-center justify-center transition-all ${selectedCategories.includes(category.id) ? 'bg-[#9D00FF] border-[#9D00FF]' : 'border-gray-300 bg-white'}`} data-id="element-76">
                    {selectedCategories.includes(category.id) && <Check size={14} className="text-white" strokeWidth={3} data-id="element-77" />}
                  </div>
                  <span className="font-medium text-gray-900 text-sm" data-id="element-78">
                    {category.label}
                  </span>
                </div>
                <span className="text-xs text-gray-500" data-id="element-79">
                  ({category.count})
                </span>
              </button>)}
          </div>
        </div>

        {/* Footer */}
        <div className="px-4 py-3 border-t border-gray-200 flex gap-2" data-id="element-80">
          <button onClick={onClearAll} className="flex-1 py-2.5 rounded-xl font-medium text-sm text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors active:scale-[0.98]" data-id="element-81">
            Clear All
          </button>
          <button onClick={onApply} className="flex-1 py-2.5 rounded-xl font-bold text-sm text-black bg-[#FFFC00] hover:bg-[#E6E300] transition-colors active:scale-[0.98]" data-id="element-82">
            Apply {activeFilterCount > 0 && `(${activeFilterCount})`}
          </button>
        </div>
      </div>
    </>;
}